module.exports = __webpack_public_path__ + "img/skill-uncheck.b6322fcc.svg";